const attachListeners = () => {
    const showDetailButton = document.querySelector('[data-show-details]');
    const summaryContainer = document.querySelector('.basket-summary-details-sticky');
    if (!summaryContainer) {
        return;
    }
    const summaryTitle = summaryContainer.querySelector('.summary-title');
    const summaryTotal = summaryContainer.querySelector('.summary-totals');
    const controlContainer = summaryContainer.querySelector('.control');
    const bottomContainer = summaryContainer.querySelector('.bottom-pricing');
    if (!showDetailButton) {
        return;
    }
    const toggleHiddensSelector = [
        {
            selector: '.edit-basket',
            className: 'hidden'
        },
        {
            selector: '.basket-lines',
            className: 'folded'
        },
        {
            selector: '.control',
            className: 'margin-bottom-plus-15px'
        },
        {
            selector: '.bottom-pricing',
            className: 'hidden'
        },
    ];
    showDetailButton.addEventListener('click', () => {
        toggleHiddensSelector.forEach(({
            selector, className
        }) => {
            summaryContainer.querySelector(selector).classList.toggle(className);
        });
        if (showDetailButton.hasAttribute('data-hide')) {
            showDetailButton.innerHTML = 'Show details<span class="brand-hi-sky-icon down"></span>';
            showDetailButton.removeAttribute('data-hide');
            summaryTitle.innerText = 'Total';
            controlContainer.appendChild(summaryTotal);
        } else {
            showDetailButton.innerHTML = 'Hide details<span class="brand-hi-sky-icon chevron-up"></span>';
            showDetailButton.setAttribute('data-hide', '');
            summaryTitle.innerText = 'Order summary';
            bottomContainer.appendChild(summaryTotal);
        }
    });
};
$(attachListeners);
